import classNames from "classnames";
import { CSSProperties, ReactNode } from "react";
import MarkdownRenderer from "../../../../common/MarkdownRenderer/MarkdownRenderer";
import "./CoreValues.scss";

type ActionItem = {
	text: string;
};

export type CoreValuesContent = {
	actions: ActionItem[];
};

const StepsOffsetList = ({
	children,
	className,
}: {
	children: ReactNode;
	className?: string;
}) => <ul className={classNames("list list--step", className)}>{children}</ul>;

const StepItem = ({
	children,
	className,
	style,
}: {
	children: ReactNode;
	className?: string;
	style?: CSSProperties;
}) => (
	<li
		className={classNames("list__item list__item--step", className)}
		style={style}>
		{children}
	</li>
);

const CoreValues = ({
	sectionContent,
}: {
	sectionContent: CoreValuesContent;
}) => {
	return (
		<section className="core-values background-container--gradient">
			<div className="content-container">
				<StepsOffsetList>
					{sectionContent.actions.map((item, index) => (
						<StepItem key={index}>
							<MarkdownRenderer>{item.text}</MarkdownRenderer>
						</StepItem>
					))}
				</StepsOffsetList>
			</div>
		</section>
	);
};

export default CoreValues;
